import React from 'react';
import ManageColumnSpecComponentVM from './ManageColumnSpecComponentVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { EnumHelper, ModalUtils, Validation } from '@singularsystems/neo-core';
import { ColumnSpecDataTypeEnum } from '../Models/Enums/ColumnSpecDataTypeEnum';

interface IManageColumnSpecComponentProps {
    viewModel: ManageColumnSpecComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageColumnSpecComponent extends React.Component<IManageColumnSpecComponentProps> {
    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                {<Neo.Card title={viewModel.managedColumnSpec.staticColumnSpecID === 0 ? TextConstants.Titles.AddColumn : TextConstants.Titles.EditColumn}>
                    <div>
                        <Neo.Form model={viewModel.managedColumnSpec}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup bindContext={viewModel.managedColumnSpec.meta.fileSpecPropertiesConcatenated} label={TextConstants.Labels.FileType}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria}
                                        bind={viewModel.managedColumnSpec.meta.staticFileSpecID}
                                        bindDisplay={viewModel.managedColumnSpec.meta.fileSpecPropertiesConcatenated}
                                        displayMember={"propertiesConcatenated"}
                                        items={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.propertiesConcatenated.localeCompare(y.propertiesConcatenated)))}
                                    />
                                </Neo.FormGroup>
                            </Neo.GridLayout>
                            <div className="row">
                                <div className="col-md-2">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.ColumnNumber}
                                        bind={viewModel.managedColumnSpec.meta.columnNumber}
                                        onChange={() => viewModel.showColumnNumberUpdateInfo()} />
                                </div>
                                <div className="col-md-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.FileFieldName}
                                        bind={viewModel.managedColumnSpec.meta.fileFieldName} />
                                </div>
                                <div className="col-md-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.TableColumnName}
                                        bind={viewModel.managedColumnSpec.meta.databaseFieldName} />
                                </div>
                            </div>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.Description}
                                    bind={viewModel.managedColumnSpec.meta.description}
                                    input={{ rows: 2 }} />
                                <Neo.GridLayout md={3}>
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.DataType}
                                        bind={viewModel.managedColumnSpec.meta.dataType}
                                        select={{ items: EnumHelper.asList(ColumnSpecDataTypeEnum), valueMember: "name", displayMember: "name" }}
                                        onChange={() => viewModel.setDateReadOnlyInd()} />
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.DateFormat}
                                        bind={viewModel.managedColumnSpec.meta.dateFormat}
                                        isReadOnly={viewModel.isReadOnly} />
                                </Neo.GridLayout>
                            </Neo.GridLayout>
                            <div className="row">
                            <Neo.FormGroup className="col-md-2"
                                label={TextConstants.Labels.AllowsNulls}
                                bind={viewModel.managedColumnSpec.meta.allowsNullsInd} />
                            <Neo.FormGroup className="col-md-2"
                                label={TextConstants.Labels.UniqueValue}
                                bind={viewModel.managedColumnSpec.meta.isUniqueInd} />
                            <Neo.FormGroup className="col-md-2"
                                label={TextConstants.Labels.IgnoreColumn}
                                bind={viewModel.managedColumnSpec.meta.ignoreColumnInd} />
                            </div>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </div>


                </Neo.Card>
                }
            </div>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", "Invalid Column.");
        }
    }
}

